var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwint = function SvgTwint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 34"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Twint_svg__a",
    cx: -78.79,
    cy: -700.95,
    fx: -78.79,
    fy: -700.95,
    r: 0.06,
    gradientTransform: "matrix(67.64 0 0 76.36 5336.99 53536.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffcc07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fec707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fbbc0f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#f8aa14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f38f1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ee711c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e94c1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#e62e20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e52521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Twint_svg__b",
    cx: -74.26,
    cy: -700.96,
    fx: -74.26,
    fy: -700.96,
    r: 0.08,
    gradientTransform: "matrix(50.49 0 0 76.44 3753.84 53599.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#07b4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0bb0e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#0ea6dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0792ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#0978bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0c56a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#044894"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      strokeWidth: 0
    },
    d: "M.67 9.92h32.66v14.15H.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.21 19c0 .11-.08.25-.18.3l-3.46 2a.45.45 0 0 1-.36 0l-3.46-2c-.1-.05-.18-.2-.18-.3v-4.01c0-.11.08-.25.18-.3l3.46-2c.1-.05.26-.05.36 0l3.46 2c.1.05.18.2.18.3V19Zm19.22-3.72h-3.1v.74h1.11v3.17h.88v-3.17h1.11v-.74Zm-14.08 0h-3.1v.74h1.11v3.17h.88v-3.17h1.11v-.74Zm8.97-.12c-.97 0-1.52.63-1.52 1.52v2.51h.87v-2.53c0-.39.23-.7.66-.7s.65.36.65.7v2.53h.87v-2.51c.01-.9-.55-1.52-1.53-1.52Zm-3.27.12v3.91h.87v-3.91h-.87Zm-2.95 1.55.03.17.82 2.19h.35l1.11-3.91h-.85l-.53 2.05-.03.22-.04-.22-.71-2.05h-.28l-.71 2.05-.04.22-.03-.22-.53-2.05h-.86l1.11 3.91h.35l.82-2.19.03-.17",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.19 17.01-.9 1.33-.46-.71.53-.8c.1-.14.31-.53.07-1.07-.2-.44-.63-.64-1.01-.64s-.79.2-1.01.64c-.25.52-.03.91.06 1.05 0 0 .3.44.54.8l.4.58.6.93s.1.15.27.15c.16 0 .26-.15.27-.16l1.42-2.1h-.78V17Zm-1.78.03-.39-.61c-.16-.27.02-.67.39-.67s.56.4.39.67c-.15.25-.39.61-.39.61Z",
    style: {
      strokeWidth: 0,
      fill: "url(#Twint_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.55 18.3-.89-1.25-.39-.61c-.16-.27.02-.67.39-.67.05 0 .09 0 .13.02l.31-.57a1.124 1.124 0 0 0-1.45.55c-.25.52-.03.91.06 1.05l1.55 2.3s.11.16.28.16.26-.14.27-.16l.47-.71-.4-.59-.33.47Z",
    style: {
      fill: "url(#Twint_svg__b)",
      strokeWidth: 0
    }
  }));
};
export default SvgTwint;